import React, { useState, useMemo } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Input } from "@/components/ui/input";

import {
  ChevronLeft,
  ChevronRight,
  ChevronsLeft,
  ChevronsRight,
  ArrowUpDown,
} from "lucide-react";

export const DataTable = ({
  data,
  columns,
  enableSort = true,
  handleSort,
  onRowClick,
}) => {
  const [sortColumn, setSortColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState("asc");

  const onSort = (column) => {
    setSortColumn(column);
    setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    handleSort(column, sortDirection);
  };

  return (
    <div>
      <Table>
        <TableHeader>
          <TableRow className="bg-muted hover:bg-muted">
            {columns.map((column) => (
              <TableHead
                key={column.key}
                onClick={() => onSort(column.key)}
                className={`${
                  enableSort ? "cursor-pointer" : ""
                } text-muted-foreground font-medium`}
              >
                {column.label}
                {enableSort && sortColumn === column.key && (
                  <ArrowUpDown className="ml-2 h-4 w-4 inline" />
                )}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {data.map((item, index) => (
            <TableRow
              key={index}
              className={[
                index % 2 === 0 ? "bg-card" : "bg-muted/50",
                onRowClick
                  ? "cursor-pointer hover:border hover:shadow-lg hover:border-primary hover:bg-primary/10 transition-all  rounded"
                  : "",
              ].join(" ")}
              onClick={() => (onRowClick ? onRowClick(item) : null)}
            >
              {columns.map((column) => (
                <TableCell key={column.key}>
                  {column.render
                    ? column.render(item)
                    : column.accessor
                    ? column.accessor(item)
                    : item[column.key]}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default DataTable;
